export const getCookie = (cookies: string, name: string) => {
  return cookies.split('; ').reduce((r, v) => {
    const parts = v.split('=');

    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};
